/* eslint-disable import/no-cycle */
import UserService from './UserService';
import CompanyService from './CompanyService';
import FaxService from './FaxService';
import OobmService from './OobmService';
import NumberService from './NumberService';
import BoxService from './BoxService';
import Inteliquent from './Inteliquent';
import ProposalService from './ProposalService';
import ProductService from './ProductService';
import AnalyticsService from './AnalyticsService';
import CallsService from './CallsService';
import VmailService from './VmailService';
import ProvisionService from './ProvisionService';
import ReportsService from './ReportsService';
import tdmService from './tdmService';
import portConfigService from './PortConfig';
import permissionGroupService from './permissionGroupService'
import store from '../../store';

const { REACT_APP_UNIFIED_URL, REACT_APP_CH_BASE_URL, REACT_APP_NY_BASE_URL, REACT_APP_AT_BASE_URL, REACT_APP_DL_BASE_URL, REACT_APP_IR_BASE_URL } = process.env;
const dataCenterUrls = {
  la: REACT_APP_UNIFIED_URL,
  ch: REACT_APP_CH_BASE_URL,
  ny: REACT_APP_NY_BASE_URL,
  at: REACT_APP_AT_BASE_URL,
  dl: REACT_APP_DL_BASE_URL,
  ir: REACT_APP_IR_BASE_URL,
};

const DEMO = false;

export var baseURL = 'http://localhost:3000/api/';
export const myEpikBaseURL = process.env.REACT_APP_MYEPIK_URL;
export const unifiedBaseURL = datacenter => {
  if (!datacenter) datacenter = store.getState().AppState?.boxDetails?.box?.datacenter || '';
  let url = dataCenterUrls[datacenter];
  if (!url) {
    console.log({ problemWithUrl: url });
    url = myEpikBaseURL;
  }
  return url;
};

export class Api {
  constructor(authToken, demo = DEMO) {
    this.token = authToken;
    this.demo = demo;
    this.users = new UserService(this, demo);
    this.faxes = new FaxService(this, demo);
    this.companies = new CompanyService(this, demo);
    this.numbers = new NumberService(this, demo);
    this.inteliquent = new Inteliquent(this, demo);
    this.boxes = new BoxService(this, demo);
    this.proposals = new ProposalService(this, demo);
    this.products = new ProductService(this, demo);
    this.analytics = new AnalyticsService(this, demo);
    this.calls = new CallsService(this, demo);
    this.vmails = new VmailService(this, demo);
    this.provision = new ProvisionService(this, demo);
    this.reports = new ReportsService(this, demo);
    this.tdm = new tdmService(this);
    this.portConfig = new portConfigService(this);
    this.permissionGroups = new permissionGroupService(this)
    this.Oobm = new OobmService(this, demo);
  }
}

export default Api;
